import { Card, Table, Tag, Space } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useWorkOrders } from '@/hooks/useWorkOrders'
import type { WorkOrder } from '@/types'
import { SCHEDA_LAVORO_STATUS_COLORS as statoColors, SCHEDA_LAVORO_STATUS_LABELS as statoLabels } from '@/constants/statuses'

const columns = [
  {
    title: 'Numero',
    dataIndex: 'numero_scheda',
    key: 'numero_scheda',
    width: 130,
    render: (v: string) => (
      <span style={{ fontWeight: 600, color: '#1677ff' }}>
        <FileTextOutlined style={{ marginRight: 4 }} />{v}
      </span>
    ),
  },
  {
    title: 'Cliente',
    dataIndex: 'customer_nome',
    key: 'customer_nome',
    render: (v: string) => v ?? '—',
  },
  {
    title: 'Veicolo',
    key: 'veicolo',
    render: (_: any, r: WorkOrder) => (
      <Space size={4}>
        <span>{[r.vehicle_marca, r.vehicle_modello].filter(Boolean).join(' ') || '—'}</span>
        {r.vehicle_targa && <Tag color="geekblue" style={{ fontWeight: 600 }}>{r.vehicle_targa}</Tag>}
      </Space>
    ),
  },
  {
    title: 'Stato',
    dataIndex: 'stato',
    key: 'stato',
    width: 120,
    render: (v: string) => <Tag color={statoColors[v] ?? 'default'}>{statoLabels[v] ?? v}</Tag>,
  },
  {
    title: 'Data',
    dataIndex: 'data_creazione',
    key: 'data_creazione',
    width: 100,
    render: (v: string) => v ? new Date(v).toLocaleDateString('it-IT') : '—',
  },
]

export function TableUltimiWoWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useWorkOrders(1, 10)
  const items: WorkOrder[] = data?.items ?? []

  return (
    <Card size="small" title="Ultimi OdL">
      <Table
        columns={columns}
        dataSource={items}
        rowKey="id"
        size="small"
        loading={isLoading}
        pagination={false}
        scroll={{ x: 600 }}
        locale={{ emptyText: 'Nessuna scheda' }}
        onRow={(r) => ({ onClick: () => navigate(`/schede-lavoro/${r.id}`), style: { cursor: 'pointer' } })}
      />
    </Card>
  )
}
